import { CalendarPreferences } from "@/features/calendar/components/Preferences/CalendarPreferences";
import type { Preferences } from "@/core/types";

type AdminCalendarPreferencesCardProps = {
  isReadOnly?: boolean;
  onUpdate?: (preferences: Preferences) => Promise<void>;
  preferences: Preferences | undefined;
};

export function AdminCalendarPreferencesCard({
  isReadOnly,
  onUpdate,
  preferences,
}: AdminCalendarPreferencesCardProps) {
  return (
    <CalendarPreferences isReadOnly={isReadOnly} onUpdate={onUpdate} preferences={preferences} />
  );
}
